export const ErrorTypes = {
    EXTERNAL_ERROR: 'external_error',
    GENERAL_ADDRESS_ERROR: 'general_address_error',
    INPUT_VALIDATION_ERROR: 'input_validation_error',
    SHIPPING_INVALID_COUNTRY_ERROR: 'shipping_invalid_country',
    EXPRESS_SHIPPING_INVALID_COUNTRY_ERROR: 'express_shipping_invalid_country',
    EXPRESS_SHIPPING_INVALID_ZIP_CODE_ERROR: 'express_shipping_invalid_zip_code',
    GENERIC_PAYPAL_EXPRESS_ERROR: 'generic_paypal_express_error',
};
